import { render, staticRenderFns } from "./ErfolgsrechnungTable.vue?vue&type=template&id=5ab54838&"
import script from "./ErfolgsrechnungTable.vue?vue&type=script&lang=ts&"
export * from "./ErfolgsrechnungTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports